import Exercise from '@/api/exercise';
import LessonVideoInfo from '@/api/lessonVideoInfo';
import { isEmpty, isNil } from 'lodash';
import {
  createI18nFields,
  createVideoFrameField,
  createMediaField
} from '../common/util';

export async function createConversationContent(
  data: { [key: string]: string },
  exercise: Exercise
) {
  if (isNil(exercise.conversation_content)) {
    return;
  }

  const conversation = exercise.conversation_content;
  conversation.parent_exercise = exercise.id;
  conversation.transcription = data['elsa_transcription'];
  conversation.sentence = data['elsa_sentence'];
  conversation.sentence_i18n = createI18nFields(data, 'elsa_sentence_i18n');

  const videoFrames = createVideoFrameField(data, 'elsa_lesson_video');
  conversation.lesson_video_list = isEmpty(videoFrames) ? [] : videoFrames;
  conversation.lesson_video = isEmpty(videoFrames)
    ? new LessonVideoInfo()
    : videoFrames[0];

  const id = await conversation.save();

  if (!isEmpty(data['elsa_audio_path'])) {
    const mediaId = await createMediaField(
      data['elsa_audio_path'],
      id,
      'exerciseconversationcontent',
      'audio'
    );

    conversation.audio_path = mediaId;
  }

  if (!isEmpty(data['elsa_image_path'])) {
    console.log('elsa_image_path', data['elsa_image_path']);
    const imageId = await createMediaField(
      data['elsa_image_path'],
      id,
      'exerciseconversationcontent',
      'image',
      'image'
    );

    conversation.image_path = imageId;
  }

  return conversation.save();
}
